/* istanbul ignore file */
import { Typography } from '@mui/material';
import SingleProjectWeeklyReportBreadcrumbs from 'domain/projects/project/weeklyreports/shared/SingleProjectWeeklyReportBreadcrumbs';
import ShowProjectWeeklyReport from 'domain/projects/project/weeklyreports/show/ShowProjectWeeklyReport';
import useProjectWeeklyReportsService, {
  UPDATE_PROJECT_WEEKLY_REPORT,
} from 'domain/projects/project/weeklyreports/ProjectWeeklyReportService';
import { useParams } from 'react-router-dom';
import { Show } from 'framework/show';
import EditProjectWeeklyReportButton from 'domain/projects/project/weeklyreports/shared/button/EditProjectWeeklyReport';
import { ShowPageLayout } from 'framework/ui/layout';
import ViewProjectPageMenu from 'domain/projects/project/Show/ViewProjectPageMenu';

const ViewProjectWeeklyReport = () => {
  const { reportId } = useParams<Dictionary<string>>();
  const { getById } = useProjectWeeklyReportsService();

  return (
    <ShowPageLayout
      entityHeader={
        <Typography variant="h1" color="brand">
          Weekly Report
        </Typography>
      }
      menu={<ViewProjectPageMenu />}
      breadcrumbs={<SingleProjectWeeklyReportBreadcrumbs />}
      buttons={[
        <EditProjectWeeklyReportButton
          source="reportId"
          key="edit-project-weekly-report"
          permissionToCheck={UPDATE_PROJECT_WEEKLY_REPORT}
        />,
      ]}
    >
      <Show getDataMethod={() => getById(reportId)}>
        <ShowProjectWeeklyReport />
      </Show>
    </ShowPageLayout>
  );
};

export default ViewProjectWeeklyReport;
